import { render, staticRenderFns } from "./RemindPerformance.vue?vue&type=template&id=7f906c5c&scoped=true"
import script from "./RemindPerformance.vue?vue&type=script&lang=js"
export * from "./RemindPerformance.vue?vue&type=script&lang=js"
import style0 from "./RemindPerformance.vue?vue&type=style&index=0&id=7f906c5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f906c5c",
  null
  
)

export default component.exports